// extracted by mini-css-extract-plugin
export default {"table":"Table_table__eFR3C","tableHeader":"Table_tableHeader__B-gAE","tableRow":"Table_tableRow__i3pJi"};